<template>
  <nav class="flex pt-3" aria-label="Breadcrumb" v-if="crumbs.length">
    <ol class="flex items-center space-x-4">
      <li>
        <RouterLink
          :to="'/'"
          class="text-secondary-400 hover:text-primary-700 focus:outline-none"
        >
          <HomeIcon class="h-5 w-5 shrink-0" aria-hidden="true" />
          <span class="sr-only">Home</span>
        </RouterLink>
      </li>
      <li v-for="(page, index) in crumbs" :key="page.text">
        <div class="flex items-center">
          <ChevronRightIcon
            class="h-5 w-5 shrink-0 text-secondary-400"
            aria-hidden="true"
          />
          <RouterLink
            :to="{
              name: page.name,
              params: { ...getCurrentRouteParams },
            }"
            :class="{ 'text-primary-600': index + 1 === crumbs.length }"
            class="ml-4 text-sm font-medium text-secondary-500 hover:text-primary-700 focus:outline-none cursor-pointer"
            >{{ page.showParams ? Object.values(route.params)[0] : page.text }}
          </RouterLink>
        </div>
      </li>
    </ol>
  </nav>
</template>
<script lang="ts" setup>
import { computed, ComputedRef, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useExtraStore } from "@/pinia/useExtraStore";
import { storeToRefs } from "pinia";

const route = useRoute();
const extraStore = useExtraStore();
const { setCurrentRoute } = extraStore;
const { getCurrentRouteParams } = storeToRefs(extraStore);
const crumbs: ComputedRef = computed(() => route.meta.breadCrumbs ?? []);

onMounted(() => {
  setCurrentRoute(route.params);
});
</script>
